var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeOutPreparing = function SvgTakeOutPreparing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6082 16.9384C19.2477 16.922 10.9436 16.9508 1.59106 16.9508C0.712266 16.9508 0 17.6631 0 18.5419C0 19.4206 0.712266 20.1329 1.59106 20.1329H2.58567V23.3333C2.58567 26.9943 5.56045 29.7333 9.22138 29.7333H22.8739C26.5348 29.7333 29.5094 26.9943 29.5094 23.3333V20.1329H30.4089C31.2876 20.1329 32 19.4206 32 18.5419C32 17.6631 31.2876 16.9508 30.4089 16.9508H28.6704C28.6492 16.9497 28.6305 16.9384 28.6082 16.9384Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6522 2C13.5928 2 12.7101 2.88783 12.7101 3.95367V6.21228H10.623C6.24839 6.21228 2.63802 9.49793 2.13987 13.7523C2.07431 14.3102 2.50762 14.8006 3.06608 14.8H28.9338C29.4922 14.8006 29.9258 14.3102 29.86 13.7523C29.3618 9.49807 25.7492 6.21228 21.3746 6.21228H19.2875V3.95367C19.2875 2.88782 18.4071 2 17.3476 2H14.6522Z",
    fill: "currentColor"
  })));
};
export default SvgTakeOutPreparing;